var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "secondary" } },
                [
                  _c("v-toolbar-title", [_vm._v("Map Service")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-menu",
                    {
                      attrs: { "offset-y": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _vm.isDefault(_vm.mapLayerData.LayerName)
                                ? _c(
                                    "v-btn",
                                    _vm._g(
                                      { attrs: { color: "success", dark: "" } },
                                      on
                                    ),
                                    [
                                      _c("v-icon", { staticClass: "mr-1" }, [
                                        _vm._v("add"),
                                      ]),
                                      _vm._v(
                                        _vm._s(_vm.$t("Button.addMapService")) +
                                          "\n            "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-list",
                        _vm._l(_vm.menuItems, function (item, index) {
                          return _c(
                            "v-list-tile",
                            {
                              key: index,
                              on: {
                                click: function ($event) {
                                  return _vm.addRequstRule(item)
                                },
                              },
                            },
                            [_c("v-list-tile-title", [_vm._v(_vm._s(item))])],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c(
                            "v-expansion-panel",
                            {
                              attrs: { expand: "", id: "header" },
                              model: {
                                value: _vm.panel,
                                callback: function ($$v) {
                                  _vm.panel = $$v
                                },
                                expression: "panel",
                              },
                            },
                            _vm._l(_vm.mapServiceList, function (mapService) {
                              return _c(
                                "v-expansion-panel-content",
                                {
                                  key: mapService.Id,
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                  Map Service: " +
                                                _vm._s(mapService.ServiceType) +
                                                "\n                  "
                                            ),
                                            _c("v-spacer"),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "actions",
                                        fn: function () {
                                          return [
                                            _vm.isDefault(
                                              _vm.mapLayerData.LayerName
                                            )
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    attrs: { color: "error" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.removeMapService(
                                                          mapService.Id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("Button.Remove")
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _vm._v(" "),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { wrap: "" } },
                                            _vm._l(
                                              mapService.ServiceConfig,
                                              function (item, i) {
                                                return _c(
                                                  "v-flex",
                                                  {
                                                    key: i,
                                                    attrs: {
                                                      xs12: "",
                                                      "pl-3": "",
                                                      "pr-3": "",
                                                    },
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: item.key,
                                                        readonly:
                                                          !_vm.isDefault(
                                                            _vm.mapLayerData
                                                              .LayerName
                                                          ),
                                                      },
                                                      model: {
                                                        value: item.value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.value",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _vm.isDefault(_vm.mapLayerData.LayerName)
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn_save",
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n        "),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          staticStyle: { "text-align": "center" },
          attrs: { color: _vm.snackColor, timeout: null, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("Button.Close")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ErrorDialog", {
        attrs: { data: _vm.errorDialog.data, title: _vm.errorDialog.title },
        model: {
          value: _vm.errorDialog.show,
          callback: function ($$v) {
            _vm.$set(_vm.errorDialog, "show", $$v)
          },
          expression: "errorDialog.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }